import { Alert, Button, Form, Modal } from "react-bootstrap";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import { Card, MuniSpinner2 } from "../../../components";
import { useContext, useEffect, useState } from "react";

import { useActaDetalleStore } from "../../../store/actaDetalleStore";
import { useActas } from "../../../hooks/useActas";
import { formatDate } from "../../../utils/common";
import Mapa from "../../../components/Mapa";
import Check from "../../../components/Icons/Check";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { format, parseISO } from "date-fns";
import PersonIcon from "@mui/icons-material/Person";
import { getActasRelacionadas, getNotificarMismoTitular } from "../../../services";
import { UserContext } from "../../../context";
import BadgeNumero from "../../../components/BadgeNumero";
import { useNotificadoresStore } from "../../../store/notificadoresStore";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import BadgeEstados from "../../../components/BadgeEstado";
import { useWindowSize } from "../../../hooks";

const ModalActaNotificar = ({ titleModal, row, setRefetch }) => {
  const { modals, handlerModal, loads } = useGeneralAppStore();
  const { actasRelacionadas, setActasRelacionadas, actasSeleccionadas, setActasSeleccionadas } = useNotificadoresStore();
  const { width } = useWindowSize();

  // const { acta, recibo } = useActaDetalleStore()
  // const { obtenerRecibo } = useActas();

  // useEffect(() => {
  //     obtenerRecibo({ pago_voluntario_id: acta.pago_voluntario_id })
  // }, [])
  const { actions } = useContext(UserContext);
  // const [actasRelacionadas, setActasRelacionadas] = useState();

  const getActasNot = async () => {
    setActasRelacionadas(await getActasRelacionadas({ plate: row?.plate, documento_titular: row?.documento_titular, user_id_notificador: actions?.user().usuarioID, estado_id: row?.estado_id }));
  };

  useEffect(() => {
    setActasSeleccionadas([{ ...row, numero_infraccion: row?.numero_acta }]);
    getActasNot();
  }, []);

  return (
    <>
      <Modal
        show={modals.includes("modal_notificar")}
        onHide={() => handlerModal({ modal: false, modalName: "modal_notificar" })}
        size="lg"
        aria-labelledby="contained-modal-title-center"
        centered
        className="p-0"
        style={{
          backgroundColor: modals.length > 1 && modals[0] === "acta_detalle" ? "rgba(0,0,0,0.4)" : "",
        }}
      >
        <div className="position-relative  pb-4">
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">{titleModal}</Modal.Title>
          </Modal.Header>
          <Modal.Body /* style={{padding:"0"}} */>
            <div className="position-relative">
              {loads.includes("actas_relacionadas") && (
                <div className="position-absolute b-danger w-100 h-100  d-flex justify-content-center" style={{ left: 0, top: 0, zIndex: "9999", background: "rgba(255,255,255,0.8)" }}>
                  <MuniSpinner2 />
                </div>
              )}
              <div className="d-flex flex-wrap row">
                <div className="d-flex flex-column gap-2 col-12 col-md-5 " style={{ maxWidth: width >= 768 && "350px" }}>
                  <p className={`fw-medium m-0`} style={{ fontSize: "12px ", color: "#374151" }}>
                    DNI Titular:{" "}
                    <span style={{ fontSize: "14px", color: "#111827" }} className={`"text-danger"} fw-bold `}>
                      {row?.documento_titular}
                    </span>
                  </p>
                  <p className={`fw-medium m-0`} style={{ fontSize: "12px ", color: "#374151" }}>
                    Dirección:{" "}
                    <span style={{ fontSize: "14px", color: "#111827" }} className="fw-bold  text-dark">
                      {row.direccion_titular ?? ""}
                    </span>
                  </p>
                  <p className={`fw-medium m-0`} style={{ fontSize: "12px ", color: "#374151" }}>
                    Patente:{" "}
                    <span style={{ fontSize: "14px", color: "#111827" }} className="fw-bold  text-dark">
                      {row.plate ?? ""}
                    </span>
                  </p>
                  <p className={`fw-medium m-0`} style={{ fontSize: "12px ", color: "#374151" }}>
                    Vehículo:{" "}
                    <span style={{ fontSize: "14px", color: "#111827" }} className="fw-bold  text-dark">
                      {row?.marca_vehiculo} {row.modelo_vehiculo ?? ""}
                    </span>
                  </p>
                  <p className={`fw-medium m-0`} style={{ fontSize: "12px ", color: "#374151" }}>
                    Tipo:{" "}
                    <span style={{ fontSize: "14px", color: "#111827" }} className="fw-bold  text-dark">
                      {row.tipo ?? ""}
                    </span>
                  </p>
                  {row?.observacion && (
                    <p className={`fw-medium m-0`} style={{ fontSize: "12px ", color: "#374151" }}>
                      Observacion:{" "}
                      <span style={{ fontSize: "14px", color: "#111827" }} className="fw-bold  text-dark">
                        {row.observacion ?? ""}
                      </span>
                    </p>
                  )}
                  {actasRelacionadas?.length > 1 && (
                    <>
                      <hr />

                      <div>
                        <p className="fw-bold d-flex  gap-2 align-items-center flex-wrap justify-content-center">
                          <PersonIcon /> Actas <BadgeEstados size={"xsm"} estado_id={row?.estado_id} /> relacionadas al titular
                        </p>
                        <div className="d-flex flex-column gap-2">
                          {actasRelacionadas
                            ?.filter((afm) => afm.id != row?.id)
                            ?.map((acta) => {
                              return (
                                <div key={acta?.id}>
                                  {acta?.estado_id == 4 && (
                                    <div className="d-flex gap-4 align-items-center">
                                      <BadgeNumero numero={acta?.numero_acta} estado_id={4} size={"md"} />
                                      <p className="m-0">{format(parseISO(acta?.fecha_notificacion), "dd/MM/yy HH:mm")}</p>
                                    </div>
                                  )}
                                  {acta?.estado_id == 8 && (
                                    <div className="d-flex gap-4 align-items-center">
                                      <BadgeNumero numero={acta?.numero_acta} estado_id={8} size={"md"} />
                                      {/* <input
                                        name={acta?.numero_acta}
                                        type="checkbox"
                                        onChange={(e) => {
                                          if (e?.target?.checked) {
                                            setActasSeleccionadas([...actasSeleccionadas, actasRelacionadas?.find((acta) => acta?.numero_acta == e?.target?.name)]);
                                          } else {
                                            setActasSeleccionadas(actasSeleccionadas?.filter((acta) => acta?.numero_acta != e?.target?.name));
                                          }
                                        }}
                                      /> */}
                                    </div>
                                  )}
                                  {acta?.estado_id == 9 && (
                                    <div className="d-flex gap-4 align-items-center">
                                      <BadgeNumero numero={acta?.numero_acta} estado_id={9} size={"md"} />
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </>
                  )}

                  <hr />
                </div>

                <div className="col-12 col-md ">
                  <div style={{ width: "100%", aspectRatio: "3/4", maxHeight: width >= 768 ? "300px" : "250px" }} className=" shadow-lg">
                    <Mapa zoom={15} latitud={row.latitud} longitud={row.longitud} />
                  </div>
                </div>

                {row.fecha_notificacion || row?.estado_id == 4 ? (
                  <>
                    <div className="col-12 mt-4 ">
                      <Alert variant="success" className="mt-2  col-6 mx-auto d-flex flex-column align-items-center gap-2">
                        <div className="bg-white d-flex flex-column align-items-center gap-1 p-2 py-4 border rounded shadow-lg w-100">
                          <div className="d-flex gap-2 align-items-end ">
                            <b className="text-center">Acta notificada</b>
                            <TaskAltIcon />
                          </div>
                          {/* <strong>Ya fue notificado</strong> */}
                          <hr className="w-100 mt-1 mb-3" />
                          {row?.fecha_notificacion && (
                            <p className={`fw-medium m-0`} style={{ fontSize: "12px " }}>
                              Fecha:{" "}
                              <span style={{ fontSize: "14px" }} className="fw-bold  ">
                                {format(parseISO(row.fecha_notificacion), "dd/MM/yy HH:mm") ?? ""}
                              </span>
                            </p>
                          )}
                        </div>
                      </Alert>
                    </div>
                  </>
                ) : row?.estado_id == 9 ? (
                  <>
                    <div className="col-12 mt-4 ">
                      <Alert variant="warning" className="mt-2  col-12 col-sm-10 col-md-8 mx-auto d-flex flex-column align-items-center gap-2">
                        <div className="bg-white d-flex flex-column align-items-center gap-1 p-2 py-4 border rounded shadow-lg w-100">
                          <ErrorOutlineIcon />
                          <strong>El acta no fue entregada</strong>
                          <hr className="w-100 mt-1 mb-3" />
                          <strong>Motivo</strong>
                          {row?.motivo_no_notificado?.motivos?.map((motivo, index) => {
                            return (
                              <div key={index}>
                                {index + 1} - {motivo?.motivo}
                              </div>
                            );
                          })}
                        </div>
                        {/* <ErrorOutlineIcon />
                                                    <strong>El acta no fue entregada</strong> */}
                      </Alert>
                    </div>
                  </>
                ) : (
                  <>
                    {loads.includes("loading_notificar") ? (
                      <MuniSpinner2 />
                    ) : (
                      <>
                        <div className="mt-2 w-100 ">
                          <hr />
                          {/* <div className="d-flex gap-4 w-100 justify-content-end">
                                                                {
                                                                    actasRelacionadas?.length > 1 &&
                                                                    <Button disabled={loads.includes('loading_notificar')} type="button" onClick={() => handlerModal({ modal: true, modalName: "notificar_seleccionadas" })} className="block mt-2 btn-md" >
                                                                        Notificar Actas Seleccionadas
                                                                    </Button>
                                                                }
                                                                {
                                                                    actasRelacionadas?.length > 1 &&
                                                                    <Button disabled={loads.includes('loading_notificar')} type="button" onClick={() => handlerModal({ modal: true, modalName: "modal_motivo_seleccionadas" })} className="block mt-2 btn-md btn-danger" >
                                                                        Sin entregar Actas Seleccionadas
                                                                    </Button>
                                                                }
                                                            </div>
                                                            <hr /> */}
                          <div className="d-flex gap-4 w-100 justify-content-end">
                            <Button
                              disabled={loads.includes("loading_notificar")}
                              type="button"
                              onClick={() => handlerModal({ modal: true, modalName: "notificar" })}
                              // setShowModalNotificar(true)}
                              /* onClick={() => setValue('notificada', true)} */ className="block mt-2 btn-md" /* onClick={notificar} */
                            >
                              Notificar Acta
                            </Button>
                            <Button
                              disabled={loads.includes("loading_notificar")}
                              type="button"
                              className="block mt-2 btn-danger btn-md"
                              onClick={() => handlerModal({ modal: true, modalName: "modal_motivo" })}
                              //  setShowModalMotivo(true)}
                              /* onClick={() => setValue('notificada', false)} */
                            >
                              Acta sin entregar
                            </Button>
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          </Modal.Body>
        </div>
      </Modal>
    </>
  );
};
export default ModalActaNotificar;
